class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.timeoutId = null;
        this.menuContent = null;
        window.header_flag = false;
        this.mainDetailsToggle = this.querySelector("details");
        this.mainDetailsToggle_summary = this.querySelector("details summary");
        this.content = this.querySelectorAll("details .mega-menu__content");


        this.mainDetailsToggle_summary.addEventListener(
            "mouseenter",
            this.onMouseEnter.bind(this)
        );

    }
    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }
    onMouseLeave() {
        window.header_flag = false;
        // console.log("onMouseLeave");
        this.close();
    }
    onMouseEnter() {
        document.querySelectorAll(".header-wrapper details").forEach((item) => {
            item.removeAttribute("open");
            item.querySelector("summary").setAttribute("aria-expanded", false);
        });
  
        window.header_flag = true;
        this.mainDetailsToggle.setAttribute("open", true);

        this.content.forEach((item) => {
            if (item.firstElementChild.firstElementChild !== null) {
                  this.menuContent =  item;
            }
        })

        if (this.menuContent != null) {
            this.menuContent.addEventListener("mouseleave", () => {
                window.header_flag = false;
                setTimeout(() => {
                    if (window.window.header_flag == false) this.onMouseLeave();
                }, 200);
            });
     
        }

    }

    onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();
        if (this.mainDetailsToggle.hasAttribute("open")) {
            this.animations.forEach((animation) => animation.play());
        } else {
            this.animations.forEach((animation) => animation.cancel());
        }
    }
    close() {
        this.mainDetailsToggle.removeAttribute("open");
        this.mainDetailsToggle
            .querySelector("summary")
            .setAttribute("aria-expanded", false);
    }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
    constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
    }

    onToggle() {
        if (!this.header) return;
        this.header.preventHide = this.mainDetailsToggle.open;

        if (
            document.documentElement.style.getPropertyValue(
                "--header-bottom-position-desktop"
            ) !== ""
        )
            return;
        document.documentElement.style.setProperty(
            "--header-bottom-position-desktop",
            `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
    }
}

customElements.define("header-menu", HeaderMenu);
